import React, { useEffect, useState } from "react";
import {
  MDBTabsPane,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBInput,
} from "mdb-react-ui-kit";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from "primereact/api";
import { format, parseISO } from "date-fns";
import { useParams } from "react-router-dom";
import { exportToPDF, exportToCSV } from "../../../helper/exportDatatable";
import "jspdf-autotable";

const convertISOToReadableTimeFormat = (date) => {
  return format(parseISO(date), "MM/dd/yy");
};

const formatRowStructureForArchiveStatusDatatable = ({ billActions }) => {
  return billActions.reduce((formattedRows, item) => {
    const actionDescription = item?.actionType?.description || "";
    const filteredDescription = actionDescription
      .replace("Print Version Ready", "")
      .trim();
    if (filteredDescription.startsWith("(C)")) {
      formattedRows.push({
        Date: convertISOToReadableTimeFormat(item?.date),
        Action: filteredDescription,
      });
    }
    return formattedRows;
  }, []);
};

const formatRowStructureForLawsStatusDatatable = ({ billActions }) => {
  return billActions
    .filter((action) => action?.billStatusCode?.name?.includes("(LC)"))
    .sort((a, b) => new Date(b.timeStamp) - new Date(a.timeStamp))
    .map((item) => ({
      Date: convertISOToReadableTimeFormat(item?.timeStamp),
      Action: item?.billStatusCode?.name || "",
    }));
};

const Status = ({ active, bill }) => {
  const { id: draftNumber } = useParams();
  const [formattedData, setFormattedData] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Date: { value: null, matchMode: FilterMatchMode.CONTAINS },
    Action: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  useEffect(() => {
    async function processBillActions() {
      let formattedRow = [];
      if (bill.hasOwnProperty("sessionId")) {
        formattedRow = formatRowStructureForLawsStatusDatatable({
          billActions: bill.draft.billStatuses,
        });
      } else {
        formattedRow = formatRowStructureForArchiveStatusDatatable({
          billActions: bill.billActions.map((billAction) => ({
            ...billAction,
            media: false,
          })),
        });
      }
      setFormattedData(formattedRow);
    }
    processBillActions();
  }, [bill]);

  // Update filters when searching
  const onGlobalFilterChange = (e) => {
    setFilters({
      global: { value: e.target.value, matchMode: FilterMatchMode.CONTAINS },
    });
  };

  //Exports
  const exportColumns = [
    { field: "Date", header: "Status Date" },
    { field: "Action", header: "Action" },
  ];

  const handlePDFExport = () => {
    exportToPDF(
      "Status",
      `${draftNumber}`,
      exportColumns,
      formattedData,
      {
        columnStyles: null,
      }
    );
  };

  const handleCSVExport = () => {
    exportToCSV(
      "Status",
      `${draftNumber}`,
      exportColumns,
      formattedData
    );
  };

  return (
    <MDBTabsPane show={active}>
      <div className="row g-1">
        <div className="col-sm"></div>
        <div className="col-sm">
          <MDBInput
            className="mb-3"
            label="Search Status..."
            type="text"
            value={filters.global.value || ""}
            onChange={onGlobalFilterChange}
          />
        </div>
        <div className="col-auto">
          <MDBDropdown className="d-flex justify-content-end mb-3">
            <MDBDropdownToggle>
              <i
                className="fa-light fa-cloud-arrow-down"
                aria-hidden="true"
              ></i>{" "}
              Export
            </MDBDropdownToggle>
            <MDBDropdownMenu>
              <MDBDropdownItem
                link
                onClick={(e) => {
                  e.preventDefault();
                  handleCSVExport();
                }}
              >
                Excel/CSV
              </MDBDropdownItem>
              <MDBDropdownItem
                link
                onClick={(e) => {
                  e.preventDefault();
                  handlePDFExport();
                }}
              >
                PDF/Print
              </MDBDropdownItem>
            </MDBDropdownMenu>
          </MDBDropdown>
        </div>
      </div>
      <DataTable
        value={formattedData}
        paginator
        rows={100}
        rowsPerPageOptions={[25, 50, 100]}
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        stripedRows
        columnResizeMode="expand"
        sortField="Date"
        sortOrder={-1}
        removableSort
        // loading={loading}
        filters={filters}
        globalFilter={globalFilter}
      >
        <Column field="Date" header="Status Date" sortable filter></Column>
        <Column field="Action" header="Action" sortable filter></Column>
      </DataTable>
    </MDBTabsPane>
  );
};

export default Status;
